var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({staticClass:"obi-image",class:_vm.classList,attrs:{"alt":_vm.attrs.alt || 'alt'}},'img',_vm.attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }